export default __webpack_public_path__ + "static/poster-0-7ece09a33471b17a0a42344b08becabe.webm";